import { apiServerRoutes } from '../constants/apiRoutes'
import { getAPICallServer, putAPICallServer } from '../utils/axios.util'

class NotificationService {
  fetchNotifications(req: any) {
    const { page } = req.body

    return getAPICallServer(
      `${apiServerRoutes.GET_NOTIFICATIONS}?page_no=${page}`,
      req,
    )
  }

  markAsReadNotifications(req: any) {
    const { id } = req.body

    return putAPICallServer(
      `${apiServerRoutes.MARK_READ_NOTIFICATIONS.replace(':id', id)}`,
      req.body,
      req,
    )
  }

  markAllAsReadNotifications(req: any) {
    return putAPICallServer(
      `${apiServerRoutes.MARK_READALL_NOTIFICATIONS}`,
      req.body,
      req,
    )
  }
}

export default new NotificationService()
